import { EmployerPage } from '../../components/Public/EmployerPage'
import { JobSeekerPage } from '../../components/Public/JobSeekerPage'
import Logo from '../../assets/logo.svg'
import MetaData from '../../components/MetaData'

export const WorkPage = () => {
    return (
        <>
            <MetaData
                title="How It Works | CareerConnect AI - Job Matching Platform"
                description="Learn how CareerConnect AI works for job seekers and employers. Simple, smart, and secure hiring and job search process with AI-powered matching."
                url="https://www.careerconnectai.com/works"
                keywords="how it works, job matching, recruitment platform, hiring process, job search, AI matching"
            />
            <main className="flex flex-col items-center px-4 md:px-8 lg:px-16 xl:px-24 py-10">
                <section className="w-full max-w-[1312px]   space-y-5">
                    <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-center md:text-left">
                        How It Works
                    </h2>
                    {/* Gradient Section */}
                    <div className="bg-gradient-to-r from-[#2C25C4] to-[#8C18C3] rounded-xl w-full min-h-[186px] flex flex-col md:flex-row justify-between items-center gap-6 p-6">
                        {/* Text */}
                        <p className="text-white text-sm md:text-base lg:text-lg leading-relaxed max-w-full md:max-w-[700px] text-center md:text-left">
                            At CareerConnectai.com, we make hiring and job searching simple, smart,
                            and secure. Whether you’re a job seeker looking for your dream role or
                            an employer searching for top talent, our platform is built to make the
                            process fast and efficient.
                        </p>

                        {/* Logo Section */}
                        <div className="bg-white rounded-xl w-full max-w-[250px] flex justify-center items-center p-4">
                            <img
                                src={Logo}
                                alt="Logo"
                                className="object-contain h-24 md:h-28 lg:h-36"
                            />
                        </div>
                    </div>
                </section>

                {/* Other Sections */}
                <JobSeekerPage />
                <EmployerPage />
            </main>
        </>

    )
}
